import { render, staticRenderFns } from "./navModel.vue?vue&type=template&id=812be800&scoped=true&"
import script from "./navModel.vue?vue&type=script&lang=ts&"
export * from "./navModel.vue?vue&type=script&lang=ts&"
import style0 from "./navModel.vue?vue&type=style&index=0&id=812be800&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "812be800",
  null
  
)

export default component.exports